const Paper = ({children}) => (
  <div className="bg-milk rounded-lg w-full h-full max-h-full overflow-y-auto">
    {children}
  </div>
);

export default Paper;
